export const siteInfo = {
  name: '51黑料网',
  slogan: '吃瓜不打烊，猛料实时追',
  description: '51黑料网是全网最具影响力的娱乐八卦爆料平台，整合51黑料吃瓜网在线观看入口、每日黑料大赛与明星塌房现场爆料。我们致力于为用户提供不打烊的独家猛料实时追踪，聚合全网黑料大瓜，满足吃瓜用户一站式浏览需求。',
  url: 'http://jtqzai.cn/',
  foundedYear: 2023,
  contact: {
    email: 'hello@jtqzai.cn',
    wechat: 'heiliao51',
    weibo: '@51黑料网官方',
    address: '中国上海市浦东新区张江高科技园区',
  },
  stats: [
    { label: '累计爆料', value: '12,580+' },
    { label: '日活用户', value: '850,000+' },
    { label: '入驻记者', value: '320+' },
    { label: '覆盖平台', value: '全网' },
  ],
};

export const faqData = [
  {
    question: '51黑料网的爆料来源可靠吗？',
    answer: '51黑料网所有爆料均经过严格的采编审核流程。我们的爆料来源包括：一线狗仔团队、圈内知情人士、剧组工作人员、粉丝站姐等。每一条爆料在发布前都会经过至少两个独立信源的交叉验证。对于独家猛料，我们还会保留原始证据材料以备查验。',
  },
  {
    question: '如何向51黑料网提供爆料线索？',
    answer: '您可以通过以下方式向我们提供爆料线索：发送邮件至 hello@jtqzai.cn，或添加我们的爆料专用微信 heiliao51。我们承诺对所有爆料者信息严格保密，并设有专门的爆料奖励机制。重大独家爆料经核实后可获得最高五万元现金奖励。',
  },
  {
    question: '51黑料网的内容多久更新一次？',
    answer: '51黑料网实行7×24小时不打烊更新机制。每日黑料板块每天上午10点和晚上8点各更新一次；突发爆料则随时发布，重大事件承诺在发生后2小时内完成首发报道。我们的编辑团队轮班值守，确保您永远不会错过任何一颗大瓜。',
  },
  {
    question: '51黑料网是否涉及侵权问题？',
    answer: '51黑料网严格遵守中国法律法规，所有内容均在法律允许的范围内进行报道。我们报道的内容均为公众人物在公共场合的行为或已公开的事件信息。对于涉及隐私的内容，我们会进行必要的脱敏处理。如有权利人认为内容侵权，可通过官方渠道联系我们处理。',
  },
  {
    question: '可以在51黑料网发表评论吗？',
    answer: '目前51黑料网以内容展示为主，暂未开放评论功能。但您可以通过我们的官方微信和微博账号参与讨论，与其他吃瓜网友一起交流看法。我们也在规划社区功能，预计将在下一阶段上线。',
  },
  {
    question: '51黑料网如何与品牌进行商务合作？',
    answer: '51黑料网欢迎各类品牌进行商务合作，包括内容植入、专题报道、活动推广等。我们的用户群体精准覆盖18-35岁的娱乐消费群体，具有较高的消费转化潜力。商务合作请发送邮件至 hello@jtqzai.cn，标题注明"商务合作"，我们的商务团队将在24小时内回复。',
  },
];